const CLASS_NAMES = {
  CONTENT_TYPE_PREFIX: 'node--type-',
  DISABLED: 'disabled',
  DISABLE_SCROLL: 'disable-scroll',
  DISABLE_SCROLL_MOBILE: 'disable-scroll-mobile',
  ERROR: 'error',
  FIELD: 'field',
  FIELD_ITEM: 'field__item',
  FIELD_ITEMS: 'field__items',
  FIELD_LABEL: 'field__label',
  FIELD_PREFIX: 'field--name-',
  FORM_ELEMENT: 'form-element',
  FORM_ELEMENT_PREFIX: 'form-element--type-',
  FORM_ELEMENT_TELEPHONE_SUFFIX: 'tel',
  FORM_ITEM_ERROR_MESSAGE: 'form-item--error-message',
  HIDDEN: 'hidden',
  INACTIVE: 'inactive',
  LOADING: 'loading',
  PARAGRAPH: 'paragraph',
  PARAGRAPH_PREFIX: 'paragraph--type--',
  PARAGRAPH_VIEW_MODE_PREFIX: 'paragraph--view-mode--',
  RADIO_GROUP: 'radio-group',
  SELECTED: 'selected',
  SCROLL_TARGET: 'scroll-target',
  VISUALLY_HIDDEN: 'visually-hidden',
};

export default CLASS_NAMES;
